export default class GoogleAutoComplete {

	constructor() {
		this.instance = self;
		this.autocomplete;
	}

	static init() {
		const self = new GoogleAutoComplete;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		window.mapDefferedLoaded = function() {
			let $element = $('.js-focus-full-search-widget-area:not(.full-search-attached)');

			if ($element.length) {
				self.initFullSearch($element);
			}
		};

		$(document).on('click', '.js-focus-full-search-widget-area:not(.full-search-attached)', function() {
			var $element = $(this);

			self.initFullSearch($element);
		});

		$(document).on('change', '.js-focus-full-search-widget-area', function() {
			if ($(this).val() == '') {
				let $form = $(this).parents('.js-input-row');

				if ($form.length == 0) {
					let $form = $(this).parents('form');
				}

				self.setLatLngInputs($form, null, null);
			}
		});

		$(document).on('keyup keypress', '.js-focus-full-search-widget-area', function(e) {
			let $this = $(this),
				$form = $this.parents('.js-input-row'),
				keyCode = e.keyCode || e.which;

			if ($form.length == 0) {
				$form = $this.parents('form');
			}

			if (keyCode === 13) {
				e.preventDefault();
				self.setLocationByName($this, $form);
			}
		});
	}

	setLocationByName($field, $form) {
		const self = this;

		if (typeof self.autocomplete !== 'undefined') {
			if (typeof self.autocomplete.gm_accessors_ != 'undefined') {
				let places = self.autocomplete.gm_accessors_.place,
					predictions = false;

				$.each(places, function(key, item) {
					if (typeof item == 'object' && typeof item.place == 'object') {
						predictions = item.predictions;
					}
				});

				if (predictions) {
					let value = false;

					$.each(predictions[0], function(key, item) {
						if (value == false) {
							value = item;
						}
					});

					var geocoder = new google.maps.Geocoder();
					geocoder.geocode({"address":value }, function(results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							$field.val(value);

							self.setLatLngInputs($form, results[0].geometry.location.lat(), results[0].geometry.location.lng());
						}
					});
				}

			}
		}
	}

	initFullSearch($element) {
		const self = this;

		let $form = $element.parents('.js-input-row');

		if ($form.length == 0) {
			$form = $element.parents('form');
		}

		let element = $element.get(0);

		if (typeof google !== 'undefined') {
			$element.addClass('full-search-attached');

			self.autocomplete = new google.maps.places.Autocomplete(element, {
				types: ['(regions)'],
				componentRestrictions: {
					country: ['uk', 'ie'],
				}
			});

			// Set the data fields to return when the user selects a place.
			self.autocomplete.setFields(['geometry']);

			// Start dropdown when typing
			self.autocomplete.addListener('place_changed', function() {
				var place = self.autocomplete.getPlace();

				if (place.geometry) {
					self.setLatLngInputs($form, place.geometry.location.lat(), place.geometry.location.lng());
				} else {
					self.setLatLngInputs($form, null, null);
				}
			});
		}
	}

	 setLatLngInputs($form, lat, lng) {
		$form.find('.js-preferences-latitude').val(lat);
		$form.find('.js-preferences-longitude').val(lng);

		$form.find('input[name="latitude"]').val(lat);
		$form.find('input[name="longitude"]').val(lng);

		$form.find('input[name="longitude"]').trigger('change');
		$form.trigger('fieldChange');
	}
}
